$(document).ready(function () {
    $('.stichworte-header').click(function () {
        $(this).hide();
        $('.stichwort').removeClass('d-none');
    });

});